var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOcrModule2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "813.000000pt",
    height: "812.000000pt",
    viewBox: "0 0 813.000000 812.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,812.000000) scale(0.100000,-0.100000)",
    fill: "red",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1742 8010 c-211 -56 -363 -203 -430 -420 -15 -51 -17 -203 -19 -1997 l-3 -1943 2780 0 2780 0 0 1020 0 1020 -758 0 c-722 0 -762 1 -836 20 -207 53 -348 183 -429 397 -21 58 -22 60 -25 991 l-3 932 -1492 -1 c-1435 0 -1495 -1 -1565 -19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5100 7131 c0 -595 4 -906 11 -934 21 -87 105 -171 195 -197 28 -8 252 -10 787 -8 l749 3 -867 1010 c-477 556 -869 1012 -871 1014 -2 2 -4 -397 -4 -888z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710 3210 l0 -730 145 0 145 0 0 295 0 295 3075 0 3075 0 0 -295 0 -295 145 0 145 0 0 730 0 730 -145 0 -145 0 0 -290 0 -290 -3075 0 -3075 0 0 290 0 290 -145 0 -145 0 0 -730z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1290 2480 l0 -290 145 0 145 0 0 290 0 290 -145 0 -145 0 0 -290z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6560 2480 l0 -290 145 0 145 0 0 290 0 290 -145 0 -145 0 0 -290z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1290 1600 l0 -290 145 0 145 0 0 290 0 290 -145 0 -145 0 0 -290z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6560 1600 l0 -290 145 0 145 0 0 290 0 290 -145 0 -145 0 0 -290z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1293 828 c6 -213 17 -272 69 -372 45 -86 165 -204 248 -245 110 -53 155 -61 368 -61 l192 0 0 139 0 139 -177 4 c-165 3 -182 5 -233 29 -70 32 -116 79 -149 149 -24 51 -26 67 -29 233 l-4 177 -145 0 -146 0 6 -192z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6558 828 c-3 -188 -4 -194 -30 -244 -15 -29 -44 -66 -65 -83 -64 -53 -109 -63 -305 -68 l-178 -5 0 -139 0 -139 188 0 c207 0 261 9 360 59 133 67 248 200 294 339 19 58 22 95 26 270 l4 202 -145 0 -145 0 -4 -192z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2460 290 l0 -140 295 0 295 0 0 140 0 140 -295 0 -295 0 0 -140z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3340 290 l0 -140 290 0 290 0 0 140 0 140 -290 0 -290 0 0 -140z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4220 290 l0 -140 290 0 290 0 0 140 0 140 -290 0 -290 0 0 -140z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5100 290 l0 -140 290 0 290 0 0 140 0 140 -290 0 -290 0 0 -140z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOcrModule2);
export default __webpack_public_path__ + "static/media/ocr_module2.ffcc5063.svg";
export { ForwardRef as ReactComponent };